import Component from '@glimmer/component';

import CIcon from 'rise-ui/components/c-icon.gjs';
import DropdownListButton from 'rise-ui/components/dropdown-list-button.gjs';

import linkToDownloadTimeSeriesOutputs from 'rise-ui/helpers/link-to-download-time-series-outputs.js';

export default class TimeSeriesOutputAllDownloadComponent extends Component {
  <template>
    <DropdownListButton
      @side="bottom-end"
      @title="Download Data for All Outputs as a File"
      as | ddlb |
    >
      <ddlb.button>
        <CIcon @icon="download" />
        View All/Download All
      </ddlb.button>
      <ddlb.link @key="csv"
        @urlOpen={{linkToDownloadTimeSeriesOutputs "csv" @filename disposition="inline"}}
        @title="View All Data as CSV File"
      >
        View All CSV
      </ddlb.link>
      <ddlb.link @key="json"
        @urlOpen={{linkToDownloadTimeSeriesOutputs "json" @filename disposition="inline"}}
        @title="View All Data as JSON File"
      >
        View All JSON
      </ddlb.link>
      <ddlb.link @key="csv"
        @noOpenIcon={{true}}
        @urlOpen={{linkToDownloadTimeSeriesOutputs "csv" @filename}}
        @target="_self"
        @title="Download All Data as CSV File"
      >
        Download All CSV
      </ddlb.link>
      <ddlb.link @key="json"
        @noOpenIcon={{true}}
        @urlOpen={{linkToDownloadTimeSeriesOutputs "json" @filename}}
        @target="_self"
        @title="Download All Data as JSON File"
      >
        Download All JSON
      </ddlb.link>
    </DropdownListButton>
  </template>
}
